exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-items{position:relative;border:1px solid #fff;padding:.75rem 1rem;display:inline-block;min-width:305px}@media screen and (max-width:991px){.social-items{min-width:267px;max-width:100%}}.social-items .btn-link{display:block;cursor:pointer}.social-items .btn-link,.social-items p{font-size:85%;font-weight:700;margin:0;padding:.25rem 0}.btns p{margin-bottom:0}.btns .btn-link,.btns .btn.label{font-size:85%}@media screen and (max-width:991px){.btns .btn.label.arrow{padding-left:3.5rem}}.presult .question{padding:0;overflow:visible}.presult .question-timeline-text{display:none}.message-nobg .message-content:after{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dc4d374","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Result.vue
// module id = 80
// module chunks = 0